"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseCard = BaseCard;
exports.default = exports.FeatureDetails = exports.BaseAttributes = exports.Attributes = exports.BaseCoreDetails = exports.SimpleValue = exports.BasicValue = exports.FieldName = exports.useStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactErrorBoundary = require("react-error-boundary");

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _styles = require("@material-ui/core/styles");

var _xDataGrid = require("@mui/x-data-grid");

var _mobxReact = require("mobx-react");

var _clsx = _interopRequireDefault(require("clsx"));

var _isObject = _interopRequireDefault(require("is-object"));

var _configuration = require("../configuration");

var _util = require("../util");

var _SanitizedHTML = _interopRequireDefault(require("../ui/SanitizedHTML"));

var _SequenceFeatureDetails = _interopRequireDefault(require("./SequenceFeatureDetails"));

var _util2 = require("./util");

var _excluded = ["id"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// these are always omitted as too detailed
var globalOmit = ['length', 'position', 'subfeatures', 'uniqueId', 'exonFrames', 'parentId', 'thickStart', 'thickEnd']; // coreDetails are omitted in some circumstances

var coreDetails = ['name', 'start', 'end', 'strand', 'refName', 'description', 'type'];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    expansionPanelDetails: {
      display: 'block',
      padding: theme.spacing(1)
    },
    expandIcon: {
      color: '#FFFFFF'
    },
    field: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    fieldDescription: {
      '&:hover': {
        background: 'yellow'
      }
    },
    fieldName: {
      wordBreak: 'break-all',
      minWidth: '90px',
      maxWidth: '150px',
      borderBottom: '1px solid #0003',
      background: theme.palette.grey[200],
      marginRight: theme.spacing(1),
      padding: theme.spacing(0.5)
    },
    fieldValue: {
      wordBreak: 'break-word',
      maxHeight: 300,
      padding: theme.spacing(0.5),
      overflow: 'auto'
    },
    fieldSubvalue: {
      wordBreak: 'break-word',
      maxHeight: 300,
      padding: theme.spacing(0.5),
      background: theme.palette.grey[100],
      border: "1px solid ".concat(theme.palette.grey[300]),
      boxSizing: 'border-box',
      overflow: 'auto'
    }
  };
});
exports.useStyles = useStyles;

function BaseCard(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? true : _ref$defaultExpanded;
  var classes = useStyles();

  var _useState = (0, _react.useState)(defaultExpanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(function (s) {
        return !s;
      });
    },
    TransitionProps: {
      unmountOnExit: true
    }
  }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
    expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
      className: classes.expandIcon
    })
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "button"
  }, " ", title)), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
    className: classes.expansionPanelDetails
  }, children));
}

var FieldName = function FieldName(_ref2) {
  var description = _ref2.description,
      name = _ref2.name,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? [] : _ref2$prefix;
  var classes = useStyles();
  var val = [].concat((0, _toConsumableArray2.default)(prefix), [name]).join('.');
  return description ? /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: description,
    placement: "left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.fieldDescription, classes.fieldName)
  }, val)) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldName
  }, val);
};

exports.FieldName = FieldName;

var BasicValue = function BasicValue(_ref3) {
  var value = _ref3.value;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldValue
  }, /*#__PURE__*/_react.default.isValidElement(value) ? value : /*#__PURE__*/_react.default.createElement(_SanitizedHTML.default, {
    html: (0, _isObject.default)(value) ? JSON.stringify(value) : String(value)
  }));
};

exports.BasicValue = BasicValue;

var SimpleValue = function SimpleValue(_ref4) {
  var name = _ref4.name,
      value = _ref4.value,
      description = _ref4.description,
      prefix = _ref4.prefix;
  var classes = useStyles();
  return value !== null && value !== undefined ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/_react.default.createElement(FieldName, {
    prefix: prefix,
    description: description,
    name: name
  }), /*#__PURE__*/_react.default.createElement(BasicValue, {
    value: value
  })) : null;
};

exports.SimpleValue = SimpleValue;

var ArrayValue = function ArrayValue(_ref5) {
  var name = _ref5.name,
      value = _ref5.value,
      description = _ref5.description,
      _ref5$prefix = _ref5.prefix,
      prefix = _ref5$prefix === void 0 ? [] : _ref5$prefix;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.length === 1 ? (0, _isObject.default)(value[0]) ? /*#__PURE__*/_react.default.createElement(Attributes, {
    attributes: value[0],
    prefix: [].concat((0, _toConsumableArray2.default)(prefix), [name])
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/_react.default.createElement(FieldName, {
    prefix: prefix,
    description: description,
    name: name
  }), /*#__PURE__*/_react.default.createElement(BasicValue, {
    value: value[0]
  })) : value.every(function (val) {
    return (0, _isObject.default)(val);
  }) ? value.map(function (val, i) {
    return /*#__PURE__*/_react.default.createElement(Attributes, {
      key: JSON.stringify(val) + '-' + i,
      attributes: val,
      prefix: [].concat((0, _toConsumableArray2.default)(prefix), [name + '-' + i])
    });
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.field
  }, /*#__PURE__*/_react.default.createElement(FieldName, {
    prefix: prefix,
    description: description,
    name: name
  }), value.map(function (val, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: JSON.stringify(val) + '-' + i,
      className: classes.fieldSubvalue
    }, /*#__PURE__*/_react.default.createElement(BasicValue, {
      value: val
    }));
  })));
};

function CoreDetails(props) {
  var feature = props.feature;
  var _ref6 = feature,
      refName = _ref6.refName,
      start = _ref6.start,
      end = _ref6.end,
      strand = _ref6.strand;
  var strandMap = {
    '-1': '-',
    '0': '',
    '1': '+'
  };
  var strandStr = strandMap[strand] ? "(".concat(strandMap[strand], ")") : '';
  var displayStart = (start + 1).toLocaleString('en-US');
  var displayEnd = end.toLocaleString('en-US');
  var displayRef = refName ? "".concat(refName, ":") : '';

  var displayedDetails = _objectSpread(_objectSpread({}, feature), {}, {
    length: (end - start).toLocaleString('en-US'),
    position: "".concat(displayRef).concat(displayStart, "..").concat(displayEnd, " ").concat(strandStr)
  });

  var coreRenderedDetails = ['Position', 'Description', 'Name', 'Length', 'Type'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, coreRenderedDetails.map(function (key) {
    return [key, displayedDetails[key.toLowerCase()]];
  }).filter(function (_ref7) {
    var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
        value = _ref8[1];

    return value !== null && value !== undefined;
  }).map(function (_ref9) {
    var _ref10 = (0, _slicedToArray2.default)(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    return /*#__PURE__*/_react.default.createElement(SimpleValue, {
      key: key,
      name: key,
      value: value
    });
  }));
}

var BaseCoreDetails = function BaseCoreDetails(props) {
  return /*#__PURE__*/_react.default.createElement(BaseCard, (0, _extends2.default)({}, props, {
    title: "Primary data"
  }), /*#__PURE__*/_react.default.createElement(CoreDetails, props));
};

exports.BaseCoreDetails = BaseCoreDetails;

var DataGridDetails = function DataGridDetails(_ref11) {
  var value = _ref11.value,
      prefix = _ref11.prefix,
      name = _ref11.name;
  var keys = Object.keys(value[0]).sort();
  var unionKeys = new Set(keys);
  value.forEach(function (val) {
    return Object.keys(val).forEach(function (k) {
      return unionKeys.add(k);
    });
  });

  if (unionKeys.size < keys.length + 5) {
    // avoids key 'id' from being used in row data
    var rows = Object.entries(value).map(function (_ref12) {
      var _ref13 = (0, _slicedToArray2.default)(_ref12, 2),
          k = _ref13[0],
          val = _ref13[1];

      var id = val.id,
          rest = (0, _objectWithoutProperties2.default)(val, _excluded);
      return _objectSpread({
        id: k,
        // used by material UI
        identifier: id
      }, rest);
    }); // avoids key 'id' from being used in column names, and tries
    // to make it at the start of the colNames array

    var colNames;

    if (unionKeys.has('id')) {
      unionKeys.delete('id');
      colNames = ['identifier'].concat((0, _toConsumableArray2.default)(unionKeys));
    } else {
      colNames = (0, _toConsumableArray2.default)(unionKeys);
    }

    var columns = colNames.map(function (val) {
      return {
        field: val,
        width: Math.max.apply(Math, (0, _toConsumableArray2.default)(rows.map(function (row) {
          var result = String(row[val]);
          return Math.min(Math.max((0, _util.measureText)(result, 14) + 50, 80), 1000);
        })))
      };
    }); // disableSelection on click helps avoid
    // https://github.com/mui-org/material-ui-x/issues/1197

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FieldName, {
      prefix: prefix,
      name: name
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: Math.min(rows.length, 100) * 20 + 50 + (rows.length < 100 ? 0 : 50),
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_xDataGrid.DataGrid, {
      disableSelectionOnClick: true,
      rowHeight: 20,
      headerHeight: 25,
      rows: rows,
      rowsPerPageOptions: [],
      hideFooterRowCount: true,
      hideFooterSelectedRowCount: true,
      columns: columns,
      hideFooter: rows.length < 100
    })));
  }

  return null;
}; // arr = ['a','b'], obj = {a:{b:'hello}}, returns hello (with special addition to grab description also)


function accessNested(arr) {
  var _obj;

  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  arr.forEach(function (elt) {
    if (obj) {
      obj = obj[elt];
    }
  });
  return typeof obj === 'string' ? obj : typeof ((_obj = obj) === null || _obj === void 0 ? void 0 : _obj.Description) === 'string' ? obj.Description : undefined;
}

var Attributes = function Attributes(props) {
  var attributes = props.attributes,
      _props$omit = props.omit,
      omit = _props$omit === void 0 ? [] : _props$omit,
      descriptions = props.descriptions,
      _props$formatter = props.formatter,
      formatter = _props$formatter === void 0 ? function (val) {
    return val;
  } : _props$formatter,
      _props$prefix = props.prefix,
      prefix = _props$prefix === void 0 ? [] : _props$prefix;
  var omits = [].concat((0, _toConsumableArray2.default)(omit), globalOmit);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Object.entries(attributes).filter(function (_ref14) {
    var _ref15 = (0, _slicedToArray2.default)(_ref14, 2),
        k = _ref15[0],
        v = _ref15[1];

    return v !== undefined && !omits.includes(k);
  }).map(function (_ref16) {
    var _ref17 = (0, _slicedToArray2.default)(_ref16, 2),
        key = _ref17[0],
        value = _ref17[1];

    if (Array.isArray(value) && value.length > 2 && value.every(function (val) {
      return (0, _isObject.default)(val);
    })) {
      return /*#__PURE__*/_react.default.createElement(DataGridDetails, {
        key: key,
        prefix: prefix,
        name: key,
        value: value
      });
    }

    var description = accessNested([].concat((0, _toConsumableArray2.default)(prefix), [key]), descriptions);

    if (Array.isArray(value)) {
      return /*#__PURE__*/_react.default.createElement(ArrayValue, {
        key: key,
        name: key,
        value: value,
        description: description,
        prefix: prefix
      });
    }

    if ((0, _isObject.default)(value)) {
      return /*#__PURE__*/_react.default.createElement(Attributes, {
        omit: omits,
        key: key,
        attributes: value,
        descriptions: descriptions,
        prefix: [].concat((0, _toConsumableArray2.default)(prefix), [key])
      });
    }

    return /*#__PURE__*/_react.default.createElement(SimpleValue, {
      key: key,
      name: key,
      value: formatter(value, key),
      description: description,
      prefix: prefix
    });
  }));
};

exports.Attributes = Attributes;

var BaseAttributes = function BaseAttributes(props) {
  var feature = props.feature;
  return /*#__PURE__*/_react.default.createElement(BaseCard, (0, _extends2.default)({}, props, {
    title: "Attributes"
  }), /*#__PURE__*/_react.default.createElement(Attributes, (0, _extends2.default)({}, props, {
    attributes: feature
  })));
};

exports.BaseAttributes = BaseAttributes;

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

var FeatureDetails = function FeatureDetails(props) {
  var _props$omit2 = props.omit,
      omit = _props$omit2 === void 0 ? [] : _props$omit2,
      model = props.model,
      feature = props.feature,
      _props$depth = props.depth,
      depth = _props$depth === void 0 ? 0 : _props$depth;
  var _feature$name = feature.name,
      name = _feature$name === void 0 ? '' : _feature$name,
      _feature$id = feature.id,
      id = _feature$id === void 0 ? '' : _feature$id,
      _feature$type = feature.type,
      type = _feature$type === void 0 ? '' : _feature$type,
      subfeatures = feature.subfeatures;
  var session = (0, _util.getSession)(model);
  var defaultSeqTypes = ['mRNA', 'transcript'];
  var sequenceTypes = (0, _configuration.getConf)(session, ['featureDetails', 'sequenceTypes']) || defaultSeqTypes;
  return /*#__PURE__*/_react.default.createElement(BaseCard, {
    title: [(0, _util2.ellipses)(name || id), type].filter(function (f) {
      return !!f;
    }).join(' - ')
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, "Core details"), /*#__PURE__*/_react.default.createElement(CoreDetails, props), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.Typography, null, "Attributes"), /*#__PURE__*/_react.default.createElement(Attributes, (0, _extends2.default)({
    attributes: feature
  }, props, {
    omit: [].concat((0, _toConsumableArray2.default)(omit), coreDetails)
  })), sequenceTypes.includes(feature.type) ? /*#__PURE__*/_react.default.createElement(_reactErrorBoundary.ErrorBoundary, {
    FallbackComponent: function FallbackComponent(_ref18) {
      var error = _ref18.error;
      return /*#__PURE__*/_react.default.createElement(_core.Typography, {
        color: "error"
      }, "Failed to fetch sequence for feature: ", "".concat(error));
    }
  }, /*#__PURE__*/_react.default.createElement(_SequenceFeatureDetails.default, props)) : null, subfeatures !== null && subfeatures !== void 0 && subfeatures.length ? /*#__PURE__*/_react.default.createElement(BaseCard, {
    title: "Subfeatures",
    defaultExpanded: !sequenceTypes.includes(feature.type)
  }, subfeatures.map(function (sub) {
    return /*#__PURE__*/_react.default.createElement(FeatureDetails, {
      key: JSON.stringify(sub),
      feature: sub,
      model: model,
      depth: depth + 1
    });
  })) : null);
};

exports.FeatureDetails = FeatureDetails;
var BaseFeatureDetails = (0, _mobxReact.observer)(function (props) {
  var model = props.model;
  var featureData = model.featureData;

  if (!featureData) {
    return null;
  }

  var feature = JSON.parse(JSON.stringify(featureData));

  if (isEmpty(feature)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(FeatureDetails, {
    model: model,
    feature: feature
  });
});
var _default = BaseFeatureDetails;
exports.default = _default;